import { render, staticRenderFns } from "./CardBasic.vue?vue&type=template&id=5e5dfc9a&"
import script from "./CardBasic.vue?vue&type=script&lang=js&"
export * from "./CardBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports